import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Label from "components/library/Label";
import Sidekick from "components/library/Sidekick";

import styles from "./TextInput.css";

export default class TextInput extends Component {
  constructor() {
    super();
    this.labelLink = Math.random()
      .toString(36)
      .substring(7);
  }

  render() {
    const {
      // TODO: We should have an "inputClassName" and a "className" for the
      // root".
      className,
      error,
      fullWidth,
      help,
      inputRef,
      label,
      // TODO: This prop is no longer used.
      // labelClassName,
      labelDisplay,
      rootClassName,
      type,
      dataCy,
      ...rest
    } = this.props;

    let sidekickTitle;
    let sidekickText;

    if (help) {
      sidekickText = help.text;
      sidekickTitle = help.title;
    } else if (error) {
      sidekickText =
        error.message || (Array.isArray(error) && error[0]) || error;
      sidekickTitle = error.title;
    }

    return (
      <div className={classNames(styles.root, rootClassName)}>
        {label && (
          <Label hidden={labelDisplay === "hidden"} htmlFor={this.labelLink}>
            {label}
          </Label>
        )}
        <input
          id={this.labelLink}
          type={type || "text"}
          className={classNames(
            styles.input,
            { [styles.fullWidth]: fullWidth, [styles.error]: !!error },
            className
          )}
          aria-invalid={!!error}
          ref={inputRef}
          data-cy={dataCy}
          {...rest}
        />
        {(sidekickText || sidekickTitle) && (
          <Sidekick hasError={!!error} title={sidekickTitle}>
            {sidekickText}
          </Sidekick>
        )}
      </div>
    );
  }
}

TextInput.propTypes = {
  type: PropTypes.oneOf([
    "email",
    "password",
    "search",
    "text",
    "url",
    "tel",
    "time",
    "number",
  ]),
  label: PropTypes.string,
  labelDisplay: PropTypes.oneOf(["visible", "hidden"]),
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  inputRef: PropTypes.func,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.instanceOf(Error),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  dataCy: PropTypes.string,
};
